export const FONT_FAMILY_INTER = 'Inter'
export const FONT_FAMILY_ICOMOON = 'icomoon'

export const INTER_FONT_FILES = {
  thin: 'Inter-Thin.ttf',
  extraLight: 'Inter-ExtraLight.ttf',
  light: 'Inter-Light.ttf',
  regular: 'Inter-Regular.ttf',
  medium: 'Inter-Medium.ttf',
  semiBold: 'Inter-SemiBold.ttf',
  bold: 'Inter-Bold.ttf',
  extraBold: 'Inter-ExtraBold.ttf',
  black: 'Inter-Black.ttf',
} as const

export const ICOMOON_FONT_FILE = 'icomoon.ttf'
